<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>

<div *ngIf="isIOSToastPwa" class="iosToastPwa" [class.isShowAnimateIOSToastPwa]="isShowAnimateIOSToastPwa" (click)="IOSToastPwa()">
  <p>
    Чтобы установить это веб-приложение на свое устройство, нажмите кнопку
    <span>«Меню»&nbsp;<img src="assets/icon/safari_action_button_38x50.png" alt="" /></span>
    и затем кнопку «На экран Домой»
  </p>
  <ion-button class="page-modal__close">
        <span class="icon-sidebar">
          <span class="icon-sidebar__top"></span>
          <span class="icon-sidebar__middle"></span>
          <span class="icon-sidebar__bottom"></span>
        </span>
  </ion-button>
</div>
